import { ref } from 'vue';
import { formatTime12h } from '../utils/time';
import { __, sprintf } from '../i18n';

const DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

export function useDealers(restUrl) {
	const dealers = ref([]);
	const isLoading = ref(true);
	const error = ref(null);

	async function fetchDealers() {
		isLoading.value = true;
		error.value = null;

		try {
			const res = await fetch(restUrl, {
				headers: { Accept: 'application/json' },
			});
			if (!res.ok) throw new Error(`Dealers request failed: ${res.status}`);
			dealers.value = await res.json();
		} catch (e) {
			error.value = e;
			dealers.value = [];
		} finally {
			isLoading.value = false;
		}
	}

	return { dealers, isLoading, error, fetchDealers };
}

// close / open
export function getDealerStatus(dealer) {
	if (!dealer?.hours || !dealer?.timezone) return null;

	let now;
	try {
		now = new Date(
			new Date().toLocaleString('en-US', { timeZone: dealer.timezone })
		);
	} catch {
		return null;
	}

	const today = dealer.hours[DAY_KEYS[now.getDay()]];
	if (!today) return null;

	if (today.is_closed) return { isOpen: false, label: __('Closed', 'dealer-locator') };
	if (today.is_24h) return { isOpen: true, label: __('Open 24 hours', 'dealer-locator') };
	if (!today.open || !today.close) return null;

	const minutesNow = now.getHours() * 60 + now.getMinutes();
	const [openH, openM] = today.open.split(':').map(Number);
	const [closeH, closeM] = today.close.split(':').map(Number);

	const openMinutes = openH * 60 + openM;
	const closeMinutes = closeH * 60 + closeM;

	const isOpen = minutesNow >= openMinutes && minutesNow < closeMinutes;

	return {
		isOpen,
		label: isOpen
			? sprintf(__('Open until %s', 'dealer-locator'), formatTime12h(today.close))
			: __('Closed', 'dealer-locator'),
	};
}
